/** Canonical statuses shared by filtering, property pickers and boards. */
const WORKFLOW_STATUSES = ["backlog", "started", "delayed", "pending", "done", "completed"] as const;
export const ISSUE_STATUSES = WORKFLOW_STATUSES;
export const TASK_STATUSES = WORKFLOW_STATUSES;
// Legacy canceled records remain readable; new work uses the canonical statuses.
export type TaskStatus = (typeof TASK_STATUSES)[number] | "canceled";
export type IssueTab = "all" | "active" | (typeof ISSUE_STATUSES)[number];
export type TaskTab = "all" | (typeof TASK_STATUSES)[number];
export const TASK_STATUS_COLOR: Record<TaskStatus, string> = {
  backlog: "#8b8d91", started: "#f2c94c",
  delayed: "#d87968", pending: "#b08a3a", done: "#80bba1", completed: "#4cb782", canceled: "#8b8d91",
};

export function isTaskStatus(status: unknown): status is TaskStatus {
  return typeof status === "string" && Object.hasOwn(TASK_STATUS_COLOR, status);
}

export function isFinalStatus(status?: string) {
  return status === "completed" || status === "canceled";
}

export function isActiveStatus(status?: string) {
  return status === "unstarted" || status === "started" || status === "delayed" || status === "pending" || status === "done";
}

export function matchesIssueTab(status: string | undefined, tab: IssueTab, hideCompleted = false) {
  return tab === "all" ? !hideCompleted || status !== "completed" : tab === "active" ? isActiveStatus(status) : status === tab;
}

export function matchesTaskTab(status: string, tab: TaskTab, hideCompleted = false) {
  return tab === "all" ? !hideCompleted || status !== "completed" : status === tab;
}
